import ShopRec from './shop-rec'
export default ShopRec
